import { Component, OnDestroy } from '@angular/core';
import { SharedServiceRegistry } from './../../../shared-service-registry';
import { CoreServiceRegistry } from './../../../../core/core-service-registry';
import { ResourceService } from 'sce-core';
import { SearchService } from './../../../search/search.service';
import { SearchParams } from './../../../search/models/search-params.model';
import { SearchStatus } from './../../../search/models/search-status.model';
import { SearchCriteria, Condition, Clause } from '../../../search/models/search-filter-model';

@Component({
  selector: 'lfwms-view-bom-popup',
  templateUrl: './view-bom-popup.component.html',
  styleUrls: ['./view-bom-popup.component.css']
})
export class ViewBomPopupComponent implements OnDestroy {

  private searchParams: SearchParams;
  private searchStatus: SearchStatus;
  public isLoading: boolean = true;
  public searchService: SearchService;
  public resourceService: ResourceService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
      private sharedServiceRegistry: SharedServiceRegistry) {
    this.resourceService = coreServiceRegistry.resourceService;
  }

  public initialize(storerKey , sku) {

    // creating search criteria for bom view
    this.searchParams = new SearchParams();
    this.searchParams.tableId = 'bomtd';
    this.searchStatus = new SearchStatus();
    const bomSearchCriteria = new SearchCriteria();
    const searchCondition = new Condition();
    const defaultClause = new Clause();
    searchCondition.isMandatory = true;
    let defaultClause2 = null;
    defaultClause.operation = '=';
    defaultClause.column = 'storerKey';
    defaultClause.value = storerKey;
    defaultClause2 = new Clause();
    defaultClause2.operation = '=';
    defaultClause2.logicalOperation = 'AND';
    defaultClause2.column = 'sku';
    defaultClause2.value = sku;
    searchCondition.clauses = [defaultClause];
    searchCondition.clauses.push(defaultClause2);
    searchCondition.operator = 'AND';
    bomSearchCriteria.conditions.push(searchCondition);

    this.searchService = this.sharedServiceRegistry
      .createSearchService(this.searchParams, this.searchStatus);
    this.searchService.fetchMetadata()
      .subscribe(() => {
        this.searchService.setSearchCriteria(bomSearchCriteria);
        this.searchService.performSearch();
        this.isLoading = false;
      });
  }

  public ngOnDestroy() {
    // Memory Cleanup
    this.searchService = null;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/app/shared/components/common/view-bom-popup/view-bom-popup.component.ts